var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.175 23.8192C24.8241 23.1705 24.8247 22.1186 24.1763 21.4692L17.7168 14.9996L24.1763 8.53003C24.8247 7.88066 24.8241 6.8287 24.175 6.18003C23.526 5.53144 22.4742 5.53144 21.8252 6.18003L13.7079 14.2923C13.317 14.6829 13.317 15.3164 13.7079 15.7069L21.8252 23.8192C22.4742 24.4678 23.526 24.4678 24.175 23.8192Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8249 23.8192C16.474 23.1705 16.4746 22.1186 15.8262 21.4692L9.36667 14.9996L15.8262 8.53003C16.4746 7.88066 16.474 6.8287 15.8249 6.18003C15.1759 5.53144 14.1241 5.53144 13.4751 6.18003L5.35777 14.2923C4.96695 14.6829 4.96695 15.3164 5.35777 15.7069L13.4751 23.8192C14.1241 24.4678 15.1759 24.4678 15.8249 23.8192Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBack);
export default __webpack_public_path__ + "static/media/calendar_back.c5b07845fdfc90a5ee64369825f55ac5.svg";
export { ForwardRef as ReactComponent };